import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { getRichTextFieldRequiredValidation } from 'shared/utils';

/**
 * Returns Yup validation schema for common custom evacuation text fields.
 */
export const getEvacuationFieldsValidationSchema = (
  t: TFunction,
  regionHasEvacZones: boolean,
): Record<string, Yup.AnySchema> => ({
  customOrders: Yup.boolean(),
  customWarnings: Yup.boolean(),
  customAdvisories: Yup.boolean(),
  customShelterInPlace: Yup.boolean(),
  evacuationOrders: Yup.string().when('customOrders', {
    is: (customOrders: boolean) => regionHasEvacZones && Boolean(customOrders),
    then: getRichTextFieldRequiredValidation(
      t('geoEventEvacuations.inputs.evacuationOrders.required'),
    ),
    otherwise: Yup.string().nullable(),
  }),
  evacuationWarnings: Yup.string().when('customWarnings', {
    is: (customWarnings: boolean) =>
      regionHasEvacZones && Boolean(customWarnings),
    then: getRichTextFieldRequiredValidation(
      t('geoEventEvacuations.inputs.evacuationWarnings.required'),
    ),
    otherwise: Yup.string().nullable(),
  }),
  evacuationAdvisories: Yup.string().when('customAdvisories', {
    is: (customAdvisories: boolean) =>
      regionHasEvacZones && Boolean(customAdvisories),
    then: getRichTextFieldRequiredValidation(
      t('geoEventEvacuations.inputs.evacuationAdvisories.required'),
    ),
    otherwise: Yup.string().nullable(),
  }),
  evacuationShelterInPlace: Yup.string().when('customShelterInPlace', {
    is: (customShelterInPlace: boolean) =>
      regionHasEvacZones && Boolean(customShelterInPlace),
    then: getRichTextFieldRequiredValidation(
      t('geoEventEvacuations.inputs.evacuationShelterInPlace.required'),
    ),
    otherwise: Yup.string().nullable(),
  }),
  evacuationNotes: Yup.string().nullable(),
  unstructuredEvacuationRegionIds: Yup.array().of(Yup.number().required()),
});
